import type { PredictionContract } from '@/services/prediction/types'

/** Port of cdc-web `src/components/knockOuts/helpers/getPlayerImage.ts`（1:1）。 */
export const getPlayerImage = (contract: PredictionContract | undefined) => {
  const isNationalTeam = contract?.team?.team_type === 'national'
  if (isNationalTeam) {
    const src = contract?.individual_profile?.national_headshot_url
    return { src: src || undefined, isFlag: false }
  }
  const headshot = contract?.individual_profile?.headshot_url
  const flag = contract?.individual_profile?.flag_url
  return { src: headshot || flag || undefined, isFlag: !headshot && !!flag }
}
